import { SessionService } from '../services/SessionService';
import { Component } from './Component';
import { PollingResult } from './PollingResult';
import { Router } from '../router/Router';
import { ApiService } from '../services/ApiService';
import { Url } from '../utils/Url';

/**
 * Component Exists.
 */
export class Exists extends PollingResult {
  /**
   * Button Reload for exist view.
   */
  static btnReload = '#btnReload';

  /**
   * Render the exists component.
   *
   * @param   {object} opts - The options to render.
   */
  render(opts) {
    Component.updateTracking({ type_page: 'compte_existant' });
    if (opts) {
      opts.keepBackButton = true;
    }

    super.render(opts);
    this.attachReload();
  }

  /**
   * Attach Reload Event.
   */
  attachReload() {
    const btnReloadDOM = document.querySelector(Exists.btnReload);

    if (btnReloadDOM) {
      document.querySelector(Exists.btnReload).addEventListener('click', () => {
        this.back();
      });
    }
  }

  /**
   * Submit action.
   * Redirect to auth url.
   */
  submit() {
    Eui.authUrl += '&redirect=false';

    if (Eui.isWebViewMode) {
      return super.submit();
    }

    const token = ApiService.invitationId;

    if (Eui.allowToken && Eui.existingAccount && token !== undefined) {
      Eui.existingAccount.authUrl += '&redirect=false';
      const retUrl = Url.getParameterValue(Eui.existingAccount.authUrl, 'return_url');

      if (retUrl !== undefined) {
        const decodedRetUrl = decodeURIComponent(decodeURIComponent(retUrl));
        const retUrlWithParam = decodedRetUrl.replace(/%s/g, token);
        let newAuthUrl = Url.replaceParameter(Eui.existingAccount.authUrl, 'return_url', retUrlWithParam);

        if (Eui.existingAccount.forceReauthent) {
          newAuthUrl = Url.addParameter(newAuthUrl, 'action', 'reauthent');
        }

        Router.closeApp({
          redirectUrl: newAuthUrl,
        });

        return;
      }
    }

    // Delete the return url if missing or wrong token
    if (Eui.allowToken && !token) {
      Eui.authUrl = Url.removeParameter(Eui.authUrl, 'return_url');
    }

    Router.closeApp({
      redirectUrl: Eui.authUrl,
    });
  }

  /**
   * Back event treatment for exists components.
   */
  back() {
    const opt = {
      url: ApiService.apiSchema.polling.exists.back.url,
      method: ApiService.apiSchema.polling.exists.back.method,
    };

    return Component.makeRequest(opt, true)
      .then(() => SessionService.restartSessionTimer());
  }

  /**
   * Make request.
   */
  static makeRequest() {
    const opts = {
      url: ApiService.apiSchema.polling.exists.url,
      method: ApiService.apiSchema.polling.exists.method,
    };

    return Component.makeRequest(opts)
      .then((requestPending) => {
        if (requestPending !== true) {
          SessionService.restartSessionTimer();
        }
      });
  }
}
